/* pc-accordion.js — progressive enhancement for FAQ / compliance accordions.
   The markup works natively with <details>/<summary> (and with button[aria-expanded]
   + panel). This adds single-open behavior within a group and a rotating chevron
   hook (.is-open). Safe no-op if nothing matches. */
(function () {
  "use strict";

  function enhanceDetailsGroups(root) {
    // Any container that opts into single-open accordion behavior.
    var groups = root.querySelectorAll('[data-accordion], .js-accordion, .pc-faq__list, .pc-course-details__list');
    groups.forEach(function (group) {
      var items = group.querySelectorAll('details');
      if (!items.length) return;
      items.forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (!d.open) return;
          items.forEach(function (other) {
            if (other !== d) other.open = false;
          });
        });
      });
    });
  }

  function enhanceButtonAccordions(root) {
    // Optional button[aria-expanded] + [data-accordion-panel] pattern.
    var triggers = root.querySelectorAll('.js-accordion__trigger, [data-accordion-trigger]');
    triggers.forEach(function (btn) {
      if (btn.dataset.pcAccordionBound) return;
      btn.dataset.pcAccordionBound = '1';
      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        var panel = btn.nextElementSibling ||
          (btn.getAttribute('aria-controls') && document.getElementById(btn.getAttribute('aria-controls')));
        btn.setAttribute('aria-expanded', String(!expanded));
        btn.classList.toggle('is-open', !expanded);
        if (panel) panel.hidden = expanded;
      });
    });
  }

  function init(root) {
    root = root || document;
    try {
      enhanceDetailsGroups(root);
      enhanceButtonAccordions(root);
    } catch (e) { /* never break the page */ }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  // Theme editor: re-init on section load.
  document.addEventListener('shopify:section:load', function (e) { init(e.target || document); });
})();
